angular.module('rjmNg.directives').directive "signupChannelsSuccess", [
  () ->
    restrict: "E"
    templateUrl: "directive.signupChannelsSuccess.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$routeParams"
      "appRoute"
      "Clients"
      "jobService"
      "jobTypes"
      "notification"
      (
        $routeParams
        appRoute
        Clients
        jobService
        jobTypes
        notification
      ) ->

        view = @

        _clientInfo = null

        view.dashboardHomeLink = appRoute('/')
        view.inviteUserLink = appRoute('/settings/user/invite')
        view.knowledgeBaseLink = 'https://support.magento.com/hc/en-us/categories/360000378193-Magento-Business-Intelligence-MBI-'
        view.loading = false

        _handleError = (message) ->
          notification.clear("global")
          notification.error("Something went wrong.", message, "global")
        
        _handleSuccess = (message) ->
          notification.clear("global")
          notification.success("Success.", message, "global")

        _queueFullUpdate = () ->
          jobService(jobTypes.FULL_UPDATE).queue(isForced : 1).then(
            _handleSuccess('Full Update Running')
          ,(error) ->
            _handleError("Failed to queue full update.")
          )

        view.$postLink = () ->
          view.loading = true
          if($routeParams.clientId)
            Clients.get($routeParams.clientId).then((clientInfo) ->
              _clientInfo = clientInfo
              _clientInfo.properties.is_implemented = true
              Clients.save(_clientInfo).then((success)->
                view.loading = false
                _handleSuccess('Account setup completed.')
                _queueFullUpdate()
              ,(error) ->
                view.loading = false
                _handleError('Failed to save completion of Account Setup')
              )
            , (error) ->
              view.loading = false
              _handleError('Failed to load client settings')
            )
          else
            view.loading = false
            _handleError('Unsupported Client')
          

        return view
    ]
]
